module.exports = __webpack_public_path__ + "static/media/8_The final lesson_ES.08b4f952.txt";